export enum PushSizeEnum {
  l = 'l',
  m = 'm',
  s = 's',
  xs = 'xs',
  xxs = 'xxs'
}
